<div class="w-full">
  <table class="detalhe-header mb-4">
    <tr>
      <td><span>Registro ANS:</span> {{ data?.cd_registro_ans }}</td>
      <td><span>Nr. competência:</span> {{ data?.nr_competencia | competencia }}</td>
      <td><span>Cód. lancto:</span> {{ data?.cd_guia_monitor }}</td>
      <td><span>Lote XTE:</span> {{ data?.nm_arquivo_envio }}</td>
    </tr>
    <tr>
      <td><span>101-Número do fornecimento:</span> {{ data?.nr_fornecimento }}</td>
      <td><span>102-Data do fornecimento:</span> {{ data?.dt_fornecimento | date: 'dd/MM/yyyy' }}</td>
      <td><span>095-Tipo de registro:</span> {{ data?.nm_tp_registro }}</td>
      <td><span>Situação arquivo: </span> {{ data?.nm_id_situacao_lote }}</td>
    </tr>
  </table>

  <p-tabs [value]="0">
    <p-tablist>
      <p-tab [value]="0">Dados gerais</p-tab>
      <p-tab [value]="1">Itens fornecidos</p-tab>
      <p-tab [value]="2">Motivos de rejeição</p-tab>
    </p-tablist>
    <p-tabpanels>
    <p-tabpanel [value]="0">
      <table class="w-full detalhe-content">
        <tbody>
          <tr>
            <td><span>103-Valor total fornecido:</span> {{ data?.vl_fornecido | number: '1.2-2' }}</td>
            <td><span>104-Valor total em tabela própria:</span> {{ data?.vl_tabela_propria | number: '1.2-2' }}</td>
            <td><span>105-Valor total de co-participação:</span> {{ data?.vl_copartic | number: '1.2-2' }}</td>
          </tr>
        </tbody>

        <tbody>
          <tr>
            <th colspan="3">
              <span>Dados do beneficiário</span>
              @if (pseudonimizarActionVisible) {
                <button
                  pButton
                  type="button"
                  class="p-button p-button-text p-0"
                  style="vertical-align: baseline"
                  [icon]="'pi ' + (pseudonimizarAction ? 'pi-eye-slash' : 'pi-eye')"
                  (click)="togglePseudonimizar()"
                  [pTooltip]="(pseudonimizarAction ? 'Desativar' : 'Ativar') + ' Pseudonimização'"
                ></button>
              }
            </th>
          </tr>

          <tr>
            <td><span>016-CNS:</span> {{ data?.nr_cns }}</td>
            <td><span>121-CPF do beneficiário:</span> {{ data?.nr_cpf_beneficiario | cpf }}</td>
            <td><span>099-Município de residência:</span> {{ data?.nm_municipio_uf }}</td>
          </tr>

          <tr>
            <td><span>017-Sexo:</span> {{ data?.nm_id_sexo }}</td>
            <td><span>018-Data nascimento:</span> {{ data?.dt_nascimento | date: 'dd/MM/yyyy' }}</td>
            <td><span>020-Nr. plano na ANS:</span> {{ data?.nr_registro_plano }}</td>
          </tr>
        </tbody>
      </table>
    </p-tabpanel>

    <p-tabpanel [value]="1">
      <ag-grid-angular
        #agGridMotivosRejeicao
        class="ag-theme-balham w-full"
        style="height: 450px"
        [rowData]="data?.row_itens_fornecidos"
        [gridOptions]="gridOptionsItens"
        >
      </ag-grid-angular>
    </p-tabpanel>

    <p-tabpanel [value]="2">
      <ag-grid-angular
        #agGridMotivosRejeicao
        class="ag-theme-balham w-full"
        style="height: 450px"
        [rowData]="data?.motivos_rejeicao"
        [gridOptions]="gridOptionsMotivosRejeicao"
        >
      </ag-grid-angular>
    </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
